import React from 'react';
import { FilterIcon, XIcon, SearchIcon } from 'lucide-react';
import { DIVISION_LEADS, TEAM_LEADS } from '../data/mockData';
import { MultiSelectFilter } from './MultiSelectFilter';
interface PipelineFiltersProps {
  selectedDivisions: string[];
  setSelectedDivisions: (values: string[]) => void;
  selectedTeams: string[];
  setSelectedTeams: (values: string[]) => void;
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  onClearFilters: () => void;
}
export const PipelineFilters: React.FC<PipelineFiltersProps> = ({
  selectedDivisions,
  setSelectedDivisions,
  selectedTeams,
  setSelectedTeams,
  searchQuery,
  setSearchQuery,
  onClearFilters
}) => {
  const availableTeams = Array.from(new Set(selectedDivisions.length > 0 ? selectedDivisions.flatMap(division => TEAM_LEADS[division] || []) : Object.values(TEAM_LEADS).flat()));
  const hasActiveFilters = selectedDivisions.length > 0 || selectedTeams.length > 0 || searchQuery !== '';
  const handleDivisionChange = (divisions: string[]) => {
    setSelectedDivisions(divisions);
    const eligibleTeams = new Set(divisions.length > 0 ? divisions.flatMap(division => TEAM_LEADS[division] || []) : Object.values(TEAM_LEADS).flat());
    setSelectedTeams(selectedTeams.filter(team => eligibleTeams.has(team)));
  };
  return <section aria-label="Pipeline filters" className="bg-white dark:bg-gray-800 border-y border-[#E4E8F0] dark:border-gray-700 px-5 sm:px-6 py-3.5 transition-colors duration-200" data-id="element-148" data-mp="1cmojxt74y415">
      <div className="flex flex-wrap items-center gap-3" data-id="element-149" data-mp="jxzpue4hyyyw">
        {/* Search Input */}
        <div className="relative" data-id="element-150" data-mp="oxcft7qo0m5p">
          <SearchIcon className="w-4 h-4 text-[#0B1856]/50 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-151" data-mp="tuvrq0zw4muh" />
          <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search borrower, loan #, officer..." className="text-sm border border-[#D7DDEA] dark:border-gray-600 rounded-sm pl-9 pr-3 py-2.5 bg-white dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#009EDB] focus:border-transparent w-64 placeholder-gray-400 dark:placeholder-gray-500 transition-colors duration-200" data-id="element-152" data-mp="20ay1uk18a7n0" />
        </div>

        <div className="h-7 w-px bg-[#E4E8F0] dark:bg-gray-600 hidden sm:block transition-colors duration-200" data-id="element-153" data-mp="a6ur168psx58"></div>

        <div className="flex items-center text-[#0B1856] dark:text-gray-300 mr-1 transition-colors duration-200" data-id="element-154" data-mp="3imejw45h4djr">
          <FilterIcon className="w-4 h-4 mr-2 text-[#009EDB]" data-id="element-155" data-mp="3dl8n9v8p064y" />
          <span className="text-[11px] font-bold uppercase tracking-[0.16em]" data-id="element-156" data-mp="3rg191bf6eijz">
            Filter pipeline
          </span>
        </div>

        <MultiSelectFilter label="Division leads" options={DIVISION_LEADS} selected={selectedDivisions} onChange={handleDivisionChange} emptyLabel="All division leads" data-id="element-157" data-mp="3mlx3mwlk6il0" />

        <MultiSelectFilter label="Team leads" options={availableTeams} selected={selectedTeams} onChange={setSelectedTeams} emptyLabel="All team leads" data-id="element-158" data-mp="2ks3tizv5djyv" />

        {/* Clear Filters */}
        {hasActiveFilters && <button onClick={onClearFilters} className="text-sm text-gray-500 dark:text-gray-400 hover:text-[#009EDB] dark:hover:text-[#009EDB] flex items-center gap-1 px-2 py-2 transition-colors" data-id="element-159" data-mp="2ftk4urp65u2t">
            <XIcon className="w-4 h-4" data-id="element-160" data-mp="38ihi2geix0op" />
            Clear
          </button>}
      </div>
    </section>;
};